import SlimSelect from "slim-select";

export default class Selects {
    constructor() {
        /**
         *
         * @type {{defaultSelects: string}}
         */
        this.defaults = {
            //elements
            defaultSelects: ".js-select",
            formSelects: ".js-form-select",
        };

        /**
         *
         * @type {NodeListOf<Element>}
         */
        this.defaultSelectElements = document.querySelectorAll(this.defaults.defaultSelects);

        /**
         *
         * @type {NodeListOf<Element>}
         */
        this.formSelectElements = document.querySelectorAll(this.defaults.formSelects);
    }

    init() {
        console.log("Selects init();");

        if (this.defaultSelectElements.length > 0) {
            this.defaultSelectElements.forEach((select) => {
                this.defaultSelects(select);
            });
        }

        if (this.formSelectElements.length > 0) {
            this.formSelectElements.forEach((select) => {
                this.defaultSelects(select);
            });
        }
    }

    defaultSelects(select) {
        new SlimSelect({
            select: select,
            showSearch: false,
        });
    }
}
